const translations = {
    edit: 'Edit Invoice',
    emailInvoice: 'Email Invoice',
    invoicePreview: 'Invoice Preview',
    invoiceSuccess: 'Invoice sent successfully',
    send: 'Send Invoice',
    sendInvoiceError: 'Error sending invoice'
};

export default translations;
